import React from "react";

function VPCustomRadioCard({ icon, text1, text2 }) {
  return (
    <div
      className={`d-flex align-items-center ps-3 pe-3  mb-3 gap-1 ob-supplier-radio-item`}
    >
      <div
        className={`d-flex align-items-start ob-supplier-radio-item-wrapper`}
      >
        <div className={"ob-supplier-radio-item-icon"}>
          <img src={icon} alt="icon" width={25} height={25} />
        </div>
        <div className={"ob-supplier-radio-item-text-container"}>
          <p className={"m-0 vp-supplier-type-item-text1"}>{text1}</p>
          <p
            className={"m-0 vp-supplier-type-item-text2"}
            dangerouslySetInnerHTML={{
              __html: text2,
            }}
          ></p>
        </div>
      </div>
    </div>
  );
}

export default VPCustomRadioCard;
